import { Box } from '@mui/material';

import FiagroTable from './FiagroTable';
import Totalizers from './Totalizers';
import { QueryParams } from '..';
import { useAuthContext } from '../../../context/AuthContextProvider';

type FiagroProps = {
  query: QueryParams;
  setQuery: (p: any) => void;
  operationInfo: any;
  handlePrint: () => void;
  handleModalOpen: () => void;
};

export default function Fiagro({
  query,
  setQuery,
  handlePrint,
  handleModalOpen,
}: FiagroProps) {
  const { auth }: any = useAuthContext();
  const hasPermission = Boolean(
    auth?.user?.subscription?.plan?.permissions?.operacoes_visao_basica,
  );

  return (
    <Box>
      <Totalizers />
      <FiagroTable
        query={query}
        setQuery={setQuery}
        hasPermission={hasPermission}
        isAuthLoading={Boolean(auth?.isLoading)}
        handlePrint={handlePrint}
        handleModalOpen={handleModalOpen}
      />
    </Box>
  );
}
